function eventFire(el, etype){
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}

var stepDefaults = {
  classes: 'shepherd-theme-arrows',
  scrollTo: true
}

var OrganizationProfileTour = new Shepherd.Tour({
  defaults: stepDefaults
})

OrganizationProfileTour.addStep('overview', {
  text: 'This is your organization\'s profile in Shift Agent. Here you can manage many different settings related to your store and its operation. Let\'s take a quick tour to get familiar.',
  buttons: [{
    text: 'Next',
    action: 'next'
  }]
})

OrganizationProfileTour.addStep('tab-layout', {
  text: 'Your organization\'s profile has a set of tabs that contain various functionalities.',
  attachTo: '.nav.nav-tabs bottom',
  tetherOptions: {
    offset: '-25px 0'
  },
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }]
})

var settingsTab = new Shepherd.Step(OrganizationProfileTour, lodash.extend({
  id: 'settings-tab',
  text: 'The settings tab displays information related to your store\'s operation: contact information, pay rate settings, etc.',
  attachTo: '.org-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left',
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

settingsTab.on('show', function () {
  var scope = angular.element(document).scope();
  scope.$apply(scope.$broadcast('sa:organizationProfile:switchTab', 0));
})
OrganizationProfileTour.addStep(settingsTab)

var deptsTab = new Shepherd.Step(OrganizationProfileTour, lodash.extend({
  id: 'depts-tab',
  text: 'The Depts & Positions tab allows you to create and edit new and old position for your store.',
  attachTo: '.org-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

deptsTab.on('show', function () {
  var scope = angular.element(document).scope();
  scope.$apply(scope.$broadcast('sa:organizationProfile:switchTab', 1));
})
OrganizationProfileTour.addStep(deptsTab)

var assignPositionsTab = new Shepherd.Step(OrganizationProfileTour, lodash.extend({
  id: 'assign-positions-tab',
  text: 'After you\'ve created some positions, the Assign Positions tab gives you the ability to assign your employees to these positions.',
  attachTo: '.org-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

assignPositionsTab.on('show', function () {
  var scope = angular.element(document).scope();
  scope.$apply(scope.$broadcast('sa:organizationProfile:switchTab', 2));
})

OrganizationProfileTour.addStep(assignPositionsTab)

var policiesTab = new Shepherd.Step(OrganizationProfileTour, lodash.extend({
  id: 'policies-tab',
  text: 'The Policies tab contains the store\'s policy on taking days off and changing availability. This is visible to all employees, but only editable by admins.',
  attachTo: '.org-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

policiesTab.on('show', function () {
  var scope = angular.element(document).scope();
  scope.$apply(scope.$broadcast('sa:organizationProfile:switchTab', 3));
})

OrganizationProfileTour.addStep(policiesTab)

var subscriptionTab = new Shepherd.Step(OrganizationProfileTour, lodash.extend({
  id: 'subscription-tab',
  text: 'Your store\'s subscription is shown on this tab and can be changed at any time. Your billing information is also available here.',
  attachTo: '.org-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

subscriptionTab.on('show', function () {
  var scope = angular.element(document).scope();
  scope.$apply(scope.$broadcast('sa:organizationProfile:switchTab', 4));
})

OrganizationProfileTour.addStep(subscriptionTab)

var smsTokensTab = new Shepherd.Step(OrganizationProfileTour, lodash.extend({
  id: 'sms-tokens-tab',
  text: 'A few features, such as store news, allow you to send text messages to your employees which requires SMS Tokens. You can purchase more of these on this tab.',
  attachTo: '.org-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

smsTokensTab.on('show', function () {
  var scope = angular.element(document).scope()
  scope.$apply(scope.$broadcast('sa:organizationProfile:switchTab', 5))
})

smsTokensTab.on('hide', function () {
  var scope = angular.element(document).scope()
  scope.$apply(scope.$broadcast('sa:organizationProfile:switchTab', 0))
})

OrganizationProfileTour.addStep(smsTokensTab)

OrganizationProfileTour.addStep('conclusion', {
  text: 'This concludes our tour of the store profile! We hope you enjoy using Shift Agent and if you have any questions or concerns, don\'t hesitate to contact us.',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Finish',
    action: 'finish'
  }]
})